import * as React from "react";

function SvgFreshdesk(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 701 699.8"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M348.7 0h262.8c48.3-.4 87.9 38.4 88.3 86.8v264.3c0 192.6-156.1 348.6-348.7 348.7h-2c-92.5.1-181.3-36.6-246.8-102A348.526 348.526 0 010 351.1C0 157.9 155.8 2.1 348.7 0z"
        fill="#25c16f"
      />
      <path
        d="M348.7 155.8c-88.5 0-160.2 71.7-160.2 160.2v109c.7 29.2 24.1 52.6 53.3 53.3h45.3v-125h-61.2v-35c3.7-65.9 58.2-117.4 124.2-117.4s120.7 51.7 124.2 117.4v35h-62v125h41v2c-.4 27-22.3 48.9-49.3 49.3h-49c-4 0-8.3 2-8.3 6 .2 4.3 3.8 8.1 8.3 8.3h49.3c35-.2 63.4-28.6 63.6-63.6v-4c24.1-5.5 41.1-27 41-51.7V318.1c2.2-90.3-69.3-162.3-160.2-162.3z"
        fill="#fff"
      />
    </svg>
  );
}

export default React.forwardRef(SvgFreshdesk);
